import {
  Divider as MantineDivider,
  DividerProps as MantineDividerProps,
} from '@mantine/core';
import { forwardRef } from 'react';

import styles from './Divider.module.css';

export type DividerProps = Omit<
  MantineDividerProps,
  'color' | 'styles' | 'classNames' | 'style'
>;

const classNames = {
  root: styles.root,
  label: styles.label,
};

export const Divider = forwardRef<HTMLDivElement, DividerProps>(
  ({ ...props }, ref) => {
    return (
      <MantineDivider ref={ref} unstyled classNames={classNames} {...props} />
    );
  }
);

Divider.displayName = 'Divider';
